var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('old-tooltip',{staticClass:"be-user",attrs:{"label":_vm.tooltip}},[_vm._v(_vm._s(_vm.formatUser(_vm.user)))])}
var staticRenderFns = []

export { render, staticRenderFns }